import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import { clrslateDarkTheme, clrslateLightTheme } from './themes';

export const clrslateLightThemeExtension = ThemeBlueprint.make({
  name: 'clrslate-light',
  params: {
    theme: {
      id: 'clrslate-light',
      title: 'ClearSlate Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={clrslateLightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const clrslateDarkThemeExtension = ThemeBlueprint.make({
  name: 'clrslate-dark',
  params: {
    theme: {
      id: 'clrslate-dark',
      title: 'ClearSlate Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={clrslateDarkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

/**
 * Frontend module that registers the ClearSlate themes with the app.
 * `pluginId: 'app'` is required — ThemeBlueprint is limited to the app plugin.
 * Add `clrslateThemeModule` to `createApp({ features: [...] })`.
 */
export const clrslateThemeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [clrslateLightThemeExtension, clrslateDarkThemeExtension],
});
